<template>
    <v-container>

        <v-row class="mb-4" align="center">
            <v-col>
                <h2 class="text-h5 font-weight-medium">
                    Paramètres
                </h2>
            </v-col>

            <v-col cols="auto">
                <v-btn variant="text" class="mr-2" prepend-icon="mdi-arrow-left" @click="goToMetadata">
                    Retour Metadata
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <p>Contenu à venir...</p>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import router from '@/router';

function goToMetadata() {
    router.push({ name: 'metadata' })
}
</script>
